import * as HEALTH_PROFESSIONAL from 'app/api/health-professional';
import { fetchData } from '../async';

export const list = queryParams =>
  fetchData('HEALTH_PROFESSIONAL_LIST', HEALTH_PROFESSIONAL.lazyHealthProfessional, queryParams);
export const perPage = queryParams =>
  fetchData(
    'HEALTH_PROFESSIONAL_LIST_PERPAGE',
    HEALTH_PROFESSIONAL.lazyHealthProfessional,
    queryParams
  );
export const search = queryParams =>
  fetchData(
    'HEALTH_PROFESSIONAL_LIST_SEARCH',
    HEALTH_PROFESSIONAL.lazyHealthProfessional,
    queryParams
  );
export const filter = queryParams =>
  fetchData(
    'HEALTH_PROFESSIONAL_LIST_FILTER',
    HEALTH_PROFESSIONAL.lazyHealthProfessional,
    queryParams
  );

export const reset = () => ({
  type: 'HEALTH_PROFESSIONAL_LIST_RESET'
});
